import BaseModelAPI from '../BaseModelAPI';

export default class UserRoleList extends BaseModelAPI {

	static entity = 'userrolelist'
	static entityName = 'userrole';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
